"use client";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { ServiceWorkerContext } from "./ServiceWorkerContext";
const DEFAULT_SERVICE_WORKER_URL = "/public/sw/filadd-service-worker.js";
export const ServiceWorkerProvider = ({ configuration, children }) => {
    const [serviceWorker, setServiceWorker] = useState(null);
    // register service worker
    useEffect(() => {
        const registerServiceWorker = () => __awaiter(void 0, void 0, void 0, function* () {
            var _a, _b;
            if ("serviceWorker" in navigator) {
                try {
                    const registration = yield navigator.serviceWorker.register(DEFAULT_SERVICE_WORKER_URL);
                    // force an update because the service worker might be already installed
                    yield registration.update();
                    // get the latest installed service worker
                    const registeredServiceWorker = (_b = (_a = registration.installing) !== null && _a !== void 0 ? _a : registration.waiting) !== null && _b !== void 0 ? _b : registration.active;
                    if (registeredServiceWorker != null) {
                        setServiceWorker(registeredServiceWorker);
                    }
                }
                catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Failed to register service worker", error);
                }
            }
        });
        void registerServiceWorker();
    }, []);
    // configure service worker
    useEffect(() => {
        if (serviceWorker == null) {
            return;
        }
        serviceWorker.postMessage({
            type: "configuration",
            payload: configuration,
        });
    }, [serviceWorker, configuration]);
    return (_jsx(ServiceWorkerContext.Provider, { value: serviceWorker, children: children }));
};
//# sourceMappingURL=ServiceWorkerProvider.js.map